import { z } from "zod/v4";
import {
  CameraSubject,
  ClientApiFeaturePathParams,
  SingleResponse,
  defineEndpoint,
  defineResource,
} from "@visioni/a3s-client-api";
import { ClipCompilationAccessMethod } from "@visioni/a3s-activity-recorder/types";
import { FEATURE_NAME } from "../constants";

export { ClipCompilationAccessMethod };

export type RecordActivityPathParams = ClientApiFeaturePathParams;

export const RecordActivityBody = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("livestream_viewed"),
  }),
  z.object({
    kind: z.literal("clip_viewed"),
    clipId: z.string().min(1),
  }),
  z.object({
    kind: z.literal("clip_compilation_viewed"),
    requestId: z.string().min(1).max(128),
    via: ClipCompilationAccessMethod,
  }),
]);
export type RecordActivityBody = z.output<typeof RecordActivityBody>;

export const ActivityRecordItem = z.object({
  subject: CameraSubject,
  kind: z.enum(["livestream_viewed", "clip_viewed", "clip_compilation_viewed"]),
  clipId: z.string().optional(),
  requestId: z.string().optional(),
  via: ClipCompilationAccessMethod.optional(),
  recordedAt: z.iso.datetime(),
});
export type ActivityRecordItem = z.output<typeof ActivityRecordItem>;

export const RecordActivityResponse = SingleResponse(ActivityRecordItem);
export type RecordActivityResponse = z.output<typeof RecordActivityResponse>;

export const activityResource = defineResource({
  feature: FEATURE_NAME,
  resource: "items",
});

export const recordActivityEndpoint = defineEndpoint(activityResource, {
  method: "POST",
  bodySchema: RecordActivityBody,
  responseSchema: RecordActivityResponse,
});
